const loansCalculator = (function () {
	const monthlyBudget = document.getElementById('monthlyBudget');
	const borrowAmountInput = document.getElementById('borrowAmount');
	const aprHelpLink = document.querySelector('.help-link');
	const aprHelpContent = document.querySelector('.help-content');
	const aprButtons = document.querySelectorAll('input[name="APR"]');
	const exactAPRContent = document.querySelector('.exactAPR-content');
	const exactAPRInput = document.getElementById('aprExactAmount');
	const checkedRadioButton = document.querySelector('input[name="years"]:checked');

	let isCustomApr = false;
	let customAprValue;

	function calculateLoanDetails(type, totalAmount, monthlyPayment, numberOfYears, apr) {
		// Calculate monthly interest rate
		const monthlyInterestRate = apr / 12 / 100;

		// Calculate total number of payments
		const numberOfPayments = numberOfYears * 12;
		let totalRepayment;
		let totalInterestPaid;

		if (type === 'borrow') {
			// Calculate monthly payment using the formula
			monthlyPayment =
				(totalAmount * monthlyInterestRate) / (1 - Math.pow(1 + monthlyInterestRate, -numberOfPayments));

			// Calculate total repayment amount
			totalRepayment = monthlyPayment * numberOfPayments;

			// Calculate total amount of interest paid
			totalInterestPaid = totalRepayment - totalAmount;
		} else {
			// Calculate loan amount (total borrowed) using the formula
			totalAmount =
				monthlyPayment / (monthlyInterestRate / (1 - Math.pow(1 + monthlyInterestRate, -numberOfPayments)));

			// Calculate total repayment amount
			totalRepayment = monthlyPayment * numberOfPayments;

			// Calculate total amount of interest paid
			totalInterestPaid = totalRepayment - totalAmount;
		}

		//- Putting the values into the html
		const monthlyPaymentAmountLocation = document.getElementById('monthlyPaymentAmount');
		const numberOfMonthsLocation = document.getElementById('numberOfMonths');
		const totalBorrowAmountLocation = document.getElementById('totalBorrowAmount');
		const totalCostOfCreditLocation = document.getElementById('totalCostOfCredit');
		const APRValueLocation = document.getElementById('APRValue');
		const totalRepayAmountLocation = document.getElementById('totalRepayAmount');

		const monthlyPaymentAmount = parseFloat(monthlyPayment).toLocaleString('en-GB', {
			style: 'currency',
			currency: 'GBP',
		});
		const totalAmountFormat = parseFloat(totalAmount).toLocaleString('en-GB', {
			style: 'currency',
			currency: 'GBP',
		});
		const totalCreditFormat = totalRepayment.toLocaleString('en-GB', {
			style: 'currency',
			currency: 'GBP',
		});
		const APRValueFormat = `${apr}%`;
		const totalRepayAmountFormat = totalInterestPaid.toLocaleString('en-GB', {
			style: 'currency',
			currency: 'GBP',
		});

		numberOfMonthsLocation.textContent = numberOfPayments;
		monthlyPaymentAmountLocation.textContent = monthlyPaymentAmount;
		totalBorrowAmountLocation.textContent = totalAmountFormat;
		totalCostOfCreditLocation.textContent = totalCreditFormat;
		APRValueLocation.textContent = APRValueFormat;
		totalRepayAmountLocation.textContent = totalRepayAmountFormat;
	}

	function setSelectedAPR(radioButtons) {
		// Initialize a variable to store the selected value
		let selectedValue = '';

		// Loop through the radio buttons to find the selected one
		radioButtons.forEach(function (radioButton) {
			if (radioButton.checked) {
				selectedValue = radioButton.value;
			}
		});

		// Now you can use the selectedValue variable as needed
		// You can also return the value if you need to use it outside of this function
		return selectedValue;
	}

	function init() {
		//- Setting the base values for the initial search.
		let borrowAmount = borrowAmountInput.value;
		let monthlyPayment = monthlyBudget.value;
		let numberOfYears = 3;
		let aprValue = setSelectedAPR(aprButtons);
		let calcType = 'budget';

		//- Monthly / Total Amount
		const calcTypeRadioButtons = document.querySelectorAll('input[name="repaymentType"]');
		calcTypeRadioButtons.forEach(function (radioButton) {
			radioButton.addEventListener('change', function () {
				const monthlyAmount = document.getElementById('monthlyAmount');
				const totalAmount = document.getElementById('totalAmount');
				calcType = this.value;
				if (this.value === 'budget') {
					monthlyAmount.classList.remove('display-none');
					totalAmount.classList.add('display-none');
				} else if (this.value === 'borrow') {
					monthlyAmount.classList.add('display-none');
					totalAmount.classList.remove('display-none');
				}
				calculateLoanDetails(
					calcType,
					borrowAmount,
					monthlyPayment,
					numberOfYears,
					isCustomApr ? customAprValue : aprValue
				);
			});
		});

		//- Monthly Budget Amount
		monthlyBudget.addEventListener('input', function (event) {
			// Check if the pressed key is not a number
			// Get the entered value
			const inputValue = event.target.value;

			// Remove any non-numeric characters from the input value
			const numericValue = inputValue.replace(/\D/g, '');

			// Set the input value to the sanitized numeric value
			event.target.value = numericValue;
			monthlyPayment = event.target.value;

			calculateLoanDetails(
				calcType,
				borrowAmount,
				event.target.value,
				numberOfYears,
				isCustomApr ? customAprValue : aprValue
			);
		});

		//- Total Amount
		borrowAmountInput.addEventListener('input', function (event) {
			// Check if the pressed key is not a number
			// Get the entered value
			const inputValue = event.target.value;

			// Remove any non-numeric characters from the input value
			const numericValue = inputValue.replace(/\D/g, '');

			// Set the input value to the sanitized numeric value
			event.target.value = numericValue;
			borrowAmount = event.target.value;

			calculateLoanDetails(
				calcType,
				event.target.value,
				monthlyPayment,
				numberOfYears,
				isCustomApr ? customAprValue : aprValue
			);
		});

		// Years
		const aprYears = document.querySelectorAll('input[name="years"]');
		aprYears.forEach(function (year) {
			year.addEventListener('click', function () {
				numberOfYears = year.value;
				calculateLoanDetails(
					calcType,
					borrowAmount,
					monthlyPayment,
					numberOfYears,
					isCustomApr ? customAprValue : aprValue
				);
			});
		});

		// APR
		aprButtons.forEach(function (button) {
			button.addEventListener('click', function () {
				if (button.value === 'Exact') {
					exactAPRContent.classList.add('active');
					aprValue = '10';
					isCustomApr = true;
					exactAPRInput.addEventListener('input', function (event) {
						const maxLength = 5;
						customAprValue = event.target.value;
						if (customAprValue.length > maxLength) {
							customAprValue = customAprValue.slice(0, maxLength);
							event.target.value = customAprValue;
						}
						calculateLoanDetails(calcType, borrowAmount, monthlyPayment, numberOfYears, customAprValue);
					});
					calculateLoanDetails(
						calcType,
						borrowAmount,
						monthlyPayment,
						numberOfYears,
						isCustomApr ? customAprValue : aprValue
					);
				} else {
					isCustomApr = false;
					exactAPRContent.classList.remove('active');
					aprValue = button.value;
					calculateLoanDetails(
						calcType,
						borrowAmount,
						monthlyPayment,
						numberOfYears,
						isCustomApr ? customAprValue : aprValue
					);
				}
			});
		});

		// APR Help Link
		aprHelpLink.addEventListener('click', function (event) {
			event.preventDefault(); // Prevent the default behavior of the link
			aprHelpLink.classList.toggle('active');
			aprHelpContent.classList.toggle('active'); // Toggle the 'active' class to show/hide the content
		});

		calculateLoanDetails(
			calcType,
			borrowAmount,
			monthlyPayment,
			numberOfYears,
			isCustomApr ? customAprValue : aprValue
		);
	}

	return {
		init: init,
		calculateLoanDetails: calculateLoanDetails,
		setSelectedAPR: setSelectedAPR,
	};
})();

document.addEventListener('DOMContentLoaded', function () {
	loansCalculator.init();
});
